import {
  SET_SAVING,
  SET_LOADING,
  SET_TARGET_DEFINITION_DIRTY as SET_TARGET_DEFINITION_DIRTY_MUTATION,
  SHOW_TARGET_HISTORY_PANEL as SHOW_TARGET_HISTORY_PANEL_MUTATION,
  SET_IS_DROPPED as SETTING_IS_DROPPED,
  SET_STREAMING_OPTION,
  SET_FETCHING_TARGET,
  FLAG_REQUEST_NUMBER
} from './mutations'

import { saveTarget } from '@/api'

import { SET_CURRENT_TARGET_DEFINITION, SET_CURRENT_TARGET } from '@/appLogic/targets/currentTarget/store/actions'

import { SET_TARGET_HAD_CHANGED } from '@/appComponents/oldWorkbench/targetDefinition/store/actions'
import { ACTIVATION_STATUS } from '@/appLogic/targets/Constants'

const module = 'WORKBENCH_'

export const INIT_WORKBENCH_FOR_TARGET = module + 'INIT_WORKBENCH_FOR_TARGET'
export const SAVE_TARGET = module + 'SAVE_TARGET'
export const SET_DATA_FROM_TARGET = module + 'SET_DATA_FROM_TARGET'
export const SELECT_NETWORK_DAY_PART = module + 'SELECT_NETWORK_DAY_PART'
export const UPDATE_SELECTED_VIEWERSHIP_NETWORKS = module + 'UPDATE_SELECTED_VIEWERSHIP_NETWORKS'
export const CLOSE_DAY_PARTS_SECTION = module + 'CLOSE_DAY_PARTS_SECTION'
export const FETCH_DATA_FROM_TARGET_FOR_GRAPHS = module + 'FETCH_DATA_FROM_TARGET_FOR_GRAPHS'
export const UPDATE_STREAMING_OPTION = module + 'UPDATE_STREAMING_OPTION'
export const SET_STREAMING_CHANGED = module + 'SET_STREAMING_CHANGED'
export const SET_TARGET_DEFINITION = module + 'SET_TARGET_DEFINITION'
export const SET_TARGET_ENVIRONMENT = module + 'SET_TARGET_ENVIRONMENT'
export const SUBMIT_TO_DC = module + 'SUBMIT_TO_DC'
export const SET_TARGET_DEFINITION_DIRTY = SET_TARGET_DEFINITION_DIRTY_MUTATION
export const SHOW_TARGET_HISTORY_PANEL = SHOW_TARGET_HISTORY_PANEL_MUTATION
export const SET_IS_DROPPED = SETTING_IS_DROPPED

class WorkbenchWCanvasSlotActionsGenerator {
  setNamespace (namespace) {
    this.namespace = namespace
  }

  //
  // Creates Init action the workbench calls in its 'created' method hook
  // Init action is responsible for fetching and setting properties for the workbench
  //
  createInitAction () {
    const functionBody = this.initActionBody
    return {
      [INIT_WORKBENCH_FOR_TARGET] (store, id) {
        functionBody(store, id)
      }
    }
  }
  //
  // *** REQUIRED TO IMPLEMENT ***
  // steps in init action should be close to the following
  // - fetch config
  // - fetch target
  // - fetch datasets from config and set them
  // - set quick add attributes
  // - set target definition
  //
  initActionBody () {
    throw new Error('You must write your init Action for the workbench')
  }
  //
  // Creates the save action for the workbench
  //
  createSaveTargetAction () {
    const getTargetData = this.targetDataToSave
    return {
      [SAVE_TARGET] ({dispatch, commit, state, getters, rootState}) {
        if (getters.isSaving) return
        commit(SET_SAVING, true)
        let dataToSave = getTargetData({ state, getters })
        // this is a messed up hacky way to do it, but it works for now
        const workbenchDataValues = ['income_data', 'age_data', 'viewership_historical',
          'metrics', 'universe', 'audience_size', 'social_affinity', 'tsp_attributes',
          'activation_path', 'brand_reach', 'networks', 'activation_path']
        const workbenchData = {}
        for (const key in dataToSave) {
          if (workbenchDataValues.includes(key)) {
            workbenchData[key] = dataToSave[key]
          }
        }
        dataToSave.workbench_data = workbenchData
        if (!dataToSave.activation_status || (dataToSave.activation_status && dataToSave.activation_status === ACTIVATION_STATUS.DRAFT)) {
          dataToSave.activation_status = ACTIVATION_STATUS.WORKING
        }
        const targetAdvertiser = this.state.currentTarget.currentTarget.advertiser
        dataToSave.advertiser = targetAdvertiser
        saveTarget(dataToSave).then(res => {
          const { display_name, id, target } = dataToSave
          // eslint-disable-next-line no-undef
          adobeAnalytics.saveTarget({
            username: rootState.auth.username,
            target: {
              name: display_name,
              id: id,
              type: target
            }
          })
          // set the current targets target Definition here...
          dispatch(SET_CURRENT_TARGET_DEFINITION, getters.targetDefinition)
          dispatch(SET_CURRENT_TARGET, res.data)
          commit(SET_TARGET_DEFINITION_DIRTY, true)
          commit(SET_LOADING, false)
          commit(SET_SAVING, false)
        })
      }
    }
  }
  //
  // *** REQUIRED TO IMPLEMENT ***
  // Use this function to pass the data to save in the action
  //
  targetDataToSave ({ state, getters }) {
    throw new Error('You have to pass data to save the target')
  }

  createFetchDataFromTargetForGraphs () {
    const retrieveDataFromTarget = this.fetchDataFromTargetForGraphs
    let that = this
    return {
      [FETCH_DATA_FROM_TARGET_FOR_GRAPHS] (store) {
        if (store.getters.isFetchingTarget && !that.hitOnce) {
          /** this code "that.hitOnce = true" was inserted so that race conditions would not occur.
           * Not sure if it will have an impact.  Pretty sure the above condition is only for
           * the initial load of the workbench
           */
          that.hitOnce = true
          return
        }
        store.commit(FLAG_REQUEST_NUMBER)
        return retrieveDataFromTarget(store)
      }
    }
  }

  //
  // *** REQUIRED TO IMPLEMENT ***
  // Use this function to fetch the target and associated data
  // Parameters: store
  fetchDataFromTargetForGraphs () {
    throw new Error('Override "fetchDataFromTargetForGraphs" this with a function that retrieves all of the data for the workbench, (graphs, metrics....)')
  }

  createSetDataFromTarget (store, data) {
    const setDataFnc = this.dataFromTargetToSet
    return {
      [SET_DATA_FROM_TARGET] ({ commit }, data) {
        setDataFnc(commit, data)
      }
    }
  }

  //
  // *** REQUIRED TO IMPLEMENT ***
  // Use this function to set the data fetched from using the target definition
  // Parameters: commit, data
  //
  dataFromTargetToSet () {
    throw new Error('Override this with a function that commits all of the data for the canvas/charts')
  }

  createTargetDirtyAction () {
    return {
      [SET_TARGET_DEFINITION_DIRTY] ({ commit }, value) {
        commit(SET_TARGET_DEFINITION_DIRTY_MUTATION, value)
      }
    }
  }
  // END: These actions are shared between LAS/AD only

  additionalActions () {
    // add additional actions if your workbench needs it
    return {}
  }

  createSetStreamingOptionAction () {
    return {
      [UPDATE_STREAMING_OPTION] ({ commit }, streamingOption) {
        commit(SET_STREAMING_OPTION, streamingOption)
      }
    }
  }

  createSetStreamingChanged () {
    return {
      [SET_STREAMING_CHANGED] ({commit}) {
        commit(SET_TARGET_HAD_CHANGED)
      }
    }
  }

  createRevisionHistoryAction () {
    return {
      [SHOW_TARGET_HISTORY_PANEL_MUTATION] (context, value) {
        context.commit(SHOW_TARGET_HISTORY_PANEL, value)
      }
    }
  }

  createActions () {
    return {
      // START: Shared on all workbenches
      ...this.createInitAction(),
      ...this.createSaveTargetAction(),
      ...this.createTargetDirtyAction(),
      ...this.createFetchDataFromTargetForGraphs(),
      ...this.createSetDataFromTarget(),
      [SET_IS_DROPPED] ({commit}, value) {
        commit(SET_IS_DROPPED, value)
      },
      // END: Shared on all workbenches
      // START: These actions are shared between LAS/AD only
      ...this.createSetStreamingOptionAction(),
      ...this.createSetStreamingChanged(),
      ...this.createRevisionHistoryAction(),
      // END: These actions are shared between LAS/AD only
      ...this.additionalActions(),
      [SET_FETCHING_TARGET]: (context, value) => {
        context.commit(SET_FETCHING_TARGET, value)
      }
    }
  }
}

export default WorkbenchWCanvasSlotActionsGenerator



// WEBPACK FOOTER //
// ./src/app/views/workbenchCanvas/store/WorkbenchWCanvasSlotActionsGenerator.js